import { Link } from "react-router-dom";
import React, { useState ,useEffect} from "react";
import "./sidebar.css"
export default function Sidebar() {

    const [showNav, setshowNav] = useState(false);
    const [scrollNav, setscrollNav] = useState(false);

    
    useEffect(() => {
        console.log("Project 页面已挂载");

        document.getElementById("app").addEventListener("scroll",  (e)=> {
             if (document.getElementById("app").scrollTop === 0) {
                    setscrollNav(false)
                } else {
                    setscrollNav(true)
                }
        })
        // 这里可以执行请求接口、订阅事件等
    }, []); // 空数组 => 只在首次挂载时执行（等价于 componentDidMount）

    return (
        <div className="sidebar">
            <i className={showNav ? "navMasker active":"navMasker"} onClick={() => setshowNav(!showNav)}></i>

            <div className={showNav ? "innerBox active":"innerBox"}>
                <div  className="navBox" >
                    <a  className="router-link-active">
                        <img  src="/image/logo.png" alt="" className="logo"/>
                    </a>
                    <div  className={showNav ? "menu inner active active":"menu inner "}onClick={() => setshowNav(!showNav)}>
                        <span ></span>
                        <span ></span>
                    </div>
                </div>
                <div  className="screenBox">
                    <div  className="navList">
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./">项目信息</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./about">关于沙龙</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./member">会员服务</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./shop">商品信息</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./join">加盟会员</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./design">空间设计</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./detail">企业简介</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="./video">视频观看</Link>
                        </div>
                        <div onClick={() => setshowNav(false)}>
                            <Link to="http://39.98.224.120/index.php">立即预约</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div  className={!showNav ? "stiky active":"stiky"}>
                <div  className="moveBox active">
                    <div  className="fadeBox">
                        <div className={scrollNav?"navBg ":"navBg faded"}>
                            <img src="/image/logo.png" alt="" className="logo logo-s"/>
                        </div>
                        <img  src="/image/logo.png" alt="" className="logo active"/>
                        <div  className={"menu " + (!showNav ? "active " : "") +  (!scrollNav?"transparent":"")} onClick={() => setshowNav(!showNav)}>
                            <span ></span>
                            <span ></span>
                            <span ></span>
                        </div>
                        <span  className={!scrollNav?"menu cn transparent":"menu cn "} onClick={() => setshowNav(!showNav)}>菜单</span>
                    </div>
                    <div  className="hoverBox transparent" style={{display:scrollNav?'none':''}}>
                        <a   className="router-link-active"></a>
                        <a   className="router-link-active">
                            <img  src="/image/logo.png" alt="" className="logo"/>
                        </a>
                        <div  className={"menu " + (!showNav ? "active " : "") +  (!scrollNav?"transparent":"")} onClick={() => setshowNav(!showNav)}>
                            <span ></span>
                            <span ></span>
                            <span ></span>
                        </div>
                        <span  className="menu cn transparent" onClick={() => setshowNav(!showNav)}>菜单</span>
                    </div> 
                </div>
            </div>


        </div>
    );
}